// extracted by mini-css-extract-plugin
export default {"question-page":"QuestionPage_question-page__Echwh","question-title":"QuestionPage_question-title__bwA5M"};